import type { HttpClient } from '~/api/client';
import { httpClient } from '~/api/client';
import type {
  CursorPagedMarketProducts,
  RecentSearchKeyword,
  SearchAutoCompletion,
} from '~/api/model';

// Response 타입 (Zod Model 재사용 — OAISchema 금지, api-typegen §0)
type SearchProductsResponse = CursorPagedMarketProducts;

export type SearchProductsParams = {
  /** 검색어 (productName) */
  productName?: string;
  /** 입점사 스코프 */
  vendorId?: number;
  categoryIds?: number[];
  displayCategoryIds?: number[];
  deliveryType?: string;
  salesTarget?: string;
  vendorName?: string;
  productType?: string;
  sortType?: string;
  size?: number;
  searchAfter?: string[];
  next?: number;
  [key: string]: unknown;
};

export type SearchAutoCompletionParams = {
  keyword: string;
  size?: number;
};

export interface SearchDataSource {
  // Query
  getSearchProducts(
    params: SearchProductsParams,
  ): Promise<SearchProductsResponse>;
  getSearchProductsCount(params: SearchProductsParams): Promise<number>;
  getSearchAutoCompletion(
    params: SearchAutoCompletionParams,
  ): Promise<SearchAutoCompletion[]>;
  getRecentSearchKeywords(): Promise<RecentSearchKeyword[]>;
  deleteRecentSearchKeywords(keywords: string[]): Promise<unknown>;
}

export class SearchDataSourceImpl implements SearchDataSource {
  // eslint-disable-next-line no-useless-constructor
  constructor(private readonly client: HttpClient = httpClient) {}

  async getSearchProducts(params: SearchProductsParams) {
    return this.client.request<SearchProductsResponse>({
      url: '/api/market-place/v1/search/products',
      method: 'get',
      params: { ...params },
    });
  }

  async getSearchProductsCount(params: SearchProductsParams) {
    return this.client.request<number>({
      url: '/api/market-place/v1/search/products/count',
      method: 'get',
      params: { ...params },
    });
  }

  async getSearchAutoCompletion(params: SearchAutoCompletionParams) {
    return this.client.request<SearchAutoCompletion[]>({
      url: '/api/market-place/v1/search/auto-completion',
      method: 'get',
      params: { ...params },
    });
  }

  async getRecentSearchKeywords() {
    return this.client.request<RecentSearchKeyword[]>({
      url: '/api/market-place/v1/recently/search-keywords',
      method: 'get',
    });
  }

  async deleteRecentSearchKeywords(keywords: string[]) {
    return this.client.request<unknown>({
      url: '/api/market-place/v1/recently/delete-keywords',
      method: 'put',
      data: { keywords },
    });
  }
}

export const searchDataSource = new SearchDataSourceImpl();
